
import { Link } from 'react-router-dom';

export default function ContactCTA() {
  return (
    <section className="py-16 md:py-20 bg-neutral-900 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-15"
        style={{
          backgroundImage: 'url("https://public.readdy.ai/ai/img_res/cc5b72233208f3fe8868e22e2f89fa3b.jpg")'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-neutral-900 via-neutral-900/80 to-neutral-900"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <div className="w-14 h-14 flex items-center justify-center bg-amber-600/15 rounded-full mx-auto mb-6">
          <i className="ri-calendar-check-line text-amber-500 text-2xl"></i>
        </div>
        <h2
          className="text-[36px] sm:text-[48px] md:text-[60px] leading-none font-bold text-white mb-4"
          style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '3px' }}
        >
          ¿LISTO PARA TU TATUAJE?
        </h2>
        <p className="text-neutral-400 text-sm md:text-base max-w-xl mx-auto mb-8">
          Si ya tienes clara tu idea, reserva directamente tu cita y empieza el proceso. Sin esperas, sin complicaciones.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            onClick={() => {
              setTimeout(() => {
                const el = document.getElementById('reservar');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }, 300);
            }}
            className="px-8 py-4 bg-amber-600 text-white font-bold uppercase tracking-wider hover:bg-amber-500 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 text-sm"
            style={{
              fontFamily: 'Bebas Neue, sans-serif',
              letterSpacing: '2px',
              clipPath: 'polygon(8px 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%, 0 8px)'
            }}
          >
            <i className="ri-calendar-line"></i>
            Reservar Cita
          </Link>
          <Link
            to="/galeria-arte-urbano"
            className="px-8 py-4 bg-transparent border-2 border-neutral-600 text-white font-bold uppercase tracking-wider hover:border-neutral-400 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 text-sm"
            style={{
              fontFamily: 'Bebas Neue, sans-serif',
              letterSpacing: '2px',
              clipPath: 'polygon(8px 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%, 0 8px)'
            }}
          >
            <i className="ri-gallery-line"></i>
            Ver Galería
          </Link>
        </div>
      </div>
    </section>
  );
}
